import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ImportCashregister from "./views/ImportCashregister";
import * as cashregistersActions from "../../../../redux/modules/cashregisters";

const mapStateToProps = state => {
  return {
    loading: state.cashregisters.loading,
    success: state.cashregisters.success,
    saved: state.cashregisters.saved,
    message: state.cashregisters.message,
    fieldErrors: state.cashregisters.formErrors,
    id: state.cashregisters.id,
    viewData: state.cashregisters.viewData,
    reducerName: "cashregisters",
    model: state.options.model,
    baseFields: state.options.baseFields,
    enabledFields: state.options.enabledFields,
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      create: cashregistersActions.importCashregister
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportCashregister);



// WEBPACK FOOTER //
// ./src/Containers/Pages/Cashregisters/Cashregisters/CashregisterImport.js